import initSlickSlider from '../utils/initSlickSlider';
import setEqualHeight from '../utils/setEqualHeight';
import { COMMON_SLICK_SLIDER_OPTIONS, BREAKPOINT } from '../utils/constants';

const selectors = {
    slider: '.js-services-slider',
    slide: '.js-services-slide',
    dotsContainer: '.js-slick-slider-navigation-dots',
    sliderWrapper: '.js-services-slider-parent',
    prevArrow: '.js-slick-slider-prev-btn',
    nextArrow: '.js-slick-slider-next-btn'
};

const setDelayedEqualHeight = ($slider) => () => {
    setTimeout(() => {
        const $slides = $slider.find(selectors.slide);
        setEqualHeight($slides);
    }, 0); // a zero delay to let the slider finish its calculations
};

const servicesSlider = () => {
    const $slider = $(selectors.slider);

    if (!$slider) {
        return;
    }

    const prevArrow = $slider.closest(selectors.sliderWrapper).find(selectors.prevArrow);
    const nextArrow = $slider.closest(selectors.sliderWrapper).find(selectors.nextArrow);
    const dotsContainer = $slider.closest(selectors.sliderWrapper).find(selectors.dotsContainer);

    const options = $.extend({}, COMMON_SLICK_SLIDER_OPTIONS, {
        prevArrow,
        nextArrow,
        appendDots: dotsContainer,
        responsive: [
            {
                breakpoint: BREAKPOINT.TABLET - 1,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });

    const setSlidesEqualHeight = setDelayedEqualHeight($slider);

    $slider.on('init', () => {
        setSlidesEqualHeight();
    });

    $slider.on('breakpoint', setSlidesEqualHeight);

    initSlickSlider($slider, options);
};
export default servicesSlider;
